export default __webpack_public_path__ + "static/media/roll-stand.442f2171.svg";